import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_VEHICLE_MANAGER } from '../redux/constants/rolesConstants';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import VehiclesHeader from '../components/vehicles/VehiclesHeader';
import VehiclesList from '../components/vehicles/VehiclesList';
import VehiclesPagination from '../components/vehicles/VehiclesPagination';

const Vehicles = () => {
  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_VEHICLE_MANAGER));
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Автомобілі'} />
        </PageTitleContainer>
        <Container>
          <VehiclesHeader readOnly={readOnly} />
          <VehiclesList />
          <VehiclesPagination />
        </Container>
      </section>
    </Suspense>
  );
};

export default Vehicles;
